module.exports = __webpack_public_path__ + "img/timer-background.197b1a11.png";